import PropTypes from 'prop-types';
import React from 'react';
import { useActions, useValues } from 'kea';

import vehiclelogic from 'src/store/vehicle';

import AssignGroupDialog from './AssignGroupDialog';
import AssignKeyDialog from './AssignKeyDialog';
import EditVehicleDialog from './EditVehicleDialog';
import ImmobiliseDialog from './ImmobiliseDialog';
import SIMDialog from './SIMDialog';
import checkRole from 'src/utils/checkRole';

import profilelogic from 'src/store/profile';

const ActionButtons = ({ row }) => {

	const { update, updateGroup, immobilise, simStatus, updateKey } = useActions(vehiclelogic);

	const { profile } = useValues(profilelogic);

	const handle_edit = (existing_vehicle) => {
		update(existing_vehicle);
	}

	const handle_group = (existing_vehicle) => {
		updateGroup(existing_vehicle);
	}
	const handle_key = (existing_vehicle) => {
		updateKey(existing_vehicle);
	}

	const handle_immobilise = (state) => {
		immobilise(state)
	}

	const handle_sim_status = (state) => {
		simStatus(state)
	}


	return (
		<div style={{ display: 'flex', flexGrow: 1 }}>
			{checkRole(profile, ['VehicleEdit']) && <EditVehicleDialog vehicle={row} OnEditVehicle={handle_edit} />}
			{checkRole(profile, ['Admin']) && <AssignGroupDialog vehicle={row} onGroupAssign={handle_group} />}
			{checkRole(profile, ['Admin']) && ['FMC130', 'FMU125'].includes(row?.tracker?.model) && <AssignKeyDialog vehicle={row} onKeyAssign={handle_key} />}
			{checkRole(profile, ['VehicleImmobilise']) && ['FMC130', 'FMU125', 'TZ-AVL05(3G)'].includes(row?.tracker?.model) && <ImmobiliseDialog vehicle={row} onImmobilise={handle_immobilise} />}
			{checkRole(profile, ['VehicleEnableTracking'], false) && <SIMDialog vehicle={row} OnSIMStatus={handle_sim_status} />}
			{/* <RemoveVehicleDialog OnRemoveVehicle={handle_remove} /> */}
		</div>
	);
};

ActionButtons.propTypes = {
	row: PropTypes.object.isRequired
};

export default ActionButtons;
